require('./bootstrap');
// require('./components/Delete');
